import baseConfig, { Config } from "../../utils/config";

// Visual query demo - Total
const totalConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "", //"/content/demo_user/architectural-plan.dwg",
  ServerBackEndUrl: "http://localhost:3000",//localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  //ServerBackEndUrl: "https://server.ai.cadviewer.com", // "https://server.demo.cadviewer.com", //"http"http://localhost:3000"://localhost:3000", //"https://server.demo.cadviewer.com", //"https://server.demo.cadviewer.com", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000", //, //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", // "https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://restapi.cadviewer.com:3000/", //"http://localhost:3000/", //"https://restapi.cadviewer.com:3000/", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"https://restapi.cadviewer.com:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/" , //"https://127.0.0.1:3000",  //"http://localhost:3000", //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/", //"http://localhost:3000",          //""http://localhost:3000",  //"https://cadviewer-conversion-server-webapp-01.azurewebsites.net/",           // This is the URL of the CADViewer back-end server
  ServerLocation: "", // leave blank  in most cases
  ServerUrl: "http://localhost:3001", //"http://vizquery.cadviewer.com", //"https://demo.cadviewer.com", //"http://localhost:3001", //"https://demo.cadviewer.com/", // "http:localhost:3001", / this is the URL of the front end server
  DisplayCoordinatesMenu: false, // display the CADViewer coordinates menu
  displayTopNavigationBar: true, // display the layout /model space navigation menu
  setSpaceObjectsCustomMenu: true, // display the SpaceObject Navigation menu
  hideLeftHamburgerMenu: false, // hide the left hamburger menu
  BaseAttributes: {
    fill: "#ffd7f4", //'#D3D300', // '#ffd7f4', // '#FFF' , //  '#D3D300', // #D3D3D3  // #FFF   #ffd7f4
    "fill-opacity": 0.0, // 0.1
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  /*  HighlightAttributes: {
      fill: "#a4d7f4",
      "fill-opacity": 0.5,
      stroke: "#a4d7f4",
      "stroke-width": 0.2,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    },
    SelectAttributes: {
      fill: "#5BBEF6",
      "fill-opacity": 0.5,
      stroke: "#5BBEF6",
      "stroke-width": 0.23,
      "stroke-linejoin": "round",
      "stroke-opacity": 1.0,
    }, */
  HighlightAttributes: {
    fill: '#Ffa500', //'#00F', //'#F4d7f4', //'#a4d7f4',
    "fill-opacity": 0.3,
    stroke: '#7B3804', //'#00F', // '#a4d7f4',
    'stroke-width': 2.5, //0.2,
    'stroke-linejoin': 'round',
    'stroke-opacity': 1.0,
  },
  SelectAttributes: {
    fill: '#F00', //'#5BFEF6', //'#5BBEF6',
    "fill-opacity": 0.3,
    stroke: '#5B0303', //'#5BBEF6',
    'stroke-linejoin': 'round',
    'stroke-width': 4, //0.23,
    'stroke-opacity': 1.0,
  },
  DefaultSpaceObjectAttributes: {   // test
    fill: '#3CB043',
    "fill-opacity": "0.3",      // fill opacity set to 0.1
    stroke: '#234F1E',
    'stroke-linejoin': 'round',
    'stroke-width': "0.2",
    'stroke-opacity': 1.0,
  },
  postFixServerToken: false,
  globalApplicationFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/Total/json/application/",
  propertySVGFilesLocation: "https://server.ai.cadviewer.com/content/custom/Total/svg/",
  propertyJSONFilesLocation:
    "https://server.ai.cadviewer.com/content/custom/Total/json/property/",
  // Default property to Load
  defautlPropertyToLoad: {
    propertyNumber: "RVWC", //"2339", // set to undefined to disable default property
    planName: "LP1", //"LP0", // set to undefined to disable default plan
  },
  enableQuickPdfPrint: true,
  chatResultDisplayMetrics: true, // Set to true to display metrics in the chat results
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:", // set te title of the top pane scroll down menu
  displayTopPaneScrollDownButton: true, // display the top pane scroll down button, true to show the top pane scroll down menu
  topRowItem1: "Property Name:", // top row items
  topRowItem2: "Property Number:", // top row items
  topRowItem3: "Plan Name:", // top row items
  enableRightJSONModalPanel: true, // enabling JSON load right side pane for property selection
  enableRightFileModalPanel: true,
  setCADViewerSkin: "dark-skin", //CADViewer Skin lightgray, black, deepblue, light-skin, dark-skin

  showLogoOnSideBarLeftPanel: true, // Set to true to display the logo on the side bar left panel
  cvjs_styleQTip_width: "320px", // set the width of the popup
  debugMode: true, // enables CADViewer debug traces in the browser
  enableHelperMethods: false,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  enableAIAssistantPictureInPicture: true, // Set to true to enable the Pop Out functionality for the AI Assistant


  enableAIChat: true,
  useAIChatV5: true,
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy",
  //aiChatV5Endpoint: "https://cadviewer-conversion-server-ai-lin-02-hddkdvedhyc8c7gp.swedencentral-01.azurewebsites.net/ai/proxy",
  aiChatV5Provider: "snowflake-agent" as
    | "snowflake"
    | "python"
    | "snowflake-agent",
  aiChatV5Mode: "Test" as "Test" | "Prod",


  aiChatV2Endpoint: "/ai/v2/chat", // Endpoint for the new AI chat service
  aiChatV3Endpoint: "/ai/v3/search-spaces", // Endpoint for the V3 AI chat service
  aiChatV4Endpoint: "http://localhost:8000/process-query-v4", // Endpoint for the V4 AI chat service
  

  setBPLayerChange: true, // SET custom HEADER for BP Retail Layer Change  - 10.55.2
  customOnLoadEndContent: true, // custom OnLoadEnd content -processing of custom content in CADViewer.js

  customOnLoadEndContentUrbanEdge: true,


  defaultLayerColorsOnLoad: [
    // set the layer colors for BP Retail
    { layer: "0", color: "#000" },
    { layer: "UE_A-WALLS", color: "#000" },
    { layer: "UE_SITE-CURBS", color: "#000" },
    { layer: "UE_TNT-LEASE LINE", color: "#000" },
    { layer: "UE_A-DEMISNG WALL", color: "#000" },
    { layer: "UE_A-DOORS & GLAZING", color: "#000" },
  ],

  enableRightEmployeePanel: false,
  enableRightEmployeePanelText: "Employees",
  enableRightArchivePanel: false,
  enableRightArchivePanelText: "Archive",
  enableHelpButton1: false,
  helpbutton1: "Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: false,
  helpbutton2: "User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  // Space Selection & Quick Actions Configuration
  enableSpaceTools: true, // Enable/disable space selection panel (works independently of AI Chat)
  spaceSelectionPosition: 'bottom-right', // Position of the space selection panel (changed from bottom-left to avoid conflict with DemoNavigation)
  enableQuickActions: true, // Enable/disable quick actions menu
  quickActionsConfig: {
    enableFinancialSummary: true, // Enable "Financial Summary" quick action
    enableOpportunityCost: true, // Enable "Opportunity Cost" quick action
  },
  enableBasicAuth: true,
  basicAuthUsername: "admin",
  basicAuthPassword: "dHB#s#wf6",
  omitSpaceObjectLayerHandling: false,

  ShowInformativeBottomPanel: true, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "aboveCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height


// Space info copy button
  enableSpaceInfoCopyButton: true, // Set to true to enable the copy button for space info
  enableSpaceInfoCopyButtonTopControl: true,
  enableSpaceInfoCopyButtonTopControlText: "Toggle Data Import",


  serverSubFolder: "/custom/Total",
  showOnlySubFolder: true

};

export default totalConfig;
